<template>
    <div class="padding_dashboard dashboard">
        <div class="padding_rightpanel dashboard__rightpanel">
                    <div class="backButtonOne">
            <button class="btn-back btn w-45px" @click="goBack">
                <v-icon class="material-icons-round"> arrow_back </v-icon>
            </button>
        </div>
            <div style = "padding-top: 15px;">
                <div class = "paymentContainer">
                    <p class = "bankType_text">IMPS/NEFT/RTGS</p>
                </div>
                <p class = "transfer_Text">Transfer money only from this account</p>
                <div class = "bankBox">
                    <v-icon class="iconColor material-icons-round">account_balance</v-icon>
                    <div class = "accountDetailsContainer">
                        <p class = "bankName_text">{{userBankName}}</p>
                        <p class = "account_text">{{userBankAccount}}</p>
                    </div>
                </div>
                <p class = "note">Note: <span class = "noteDescription">Transfer from any other bank account will be declined and refunded within 5-7 workings days.</span></p>
                <p class = "following_bank_account">To the following bank account:</p>
                <div>
                    <div class = "contentContainer">
                        <div class = "leftContainer">
                            <p class = "white-box-heading">Account Number</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[2].value}}</p>
                                <v-icon @click="copyToClipboard(2)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                        <div class = "rightContainer">
                            <p class = "white-box-heading">IFSC code</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[3].value}}</p>
                                <v-icon @click="copyToClipboard(3)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                    </div>
                    <div class = "contentContainer">
                        <div class = "leftContainer">
                            <p class = "white-box-heading">Account Type</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[4].value}}</p>
                                <v-icon @click="copyToClipboard(4)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                        <div class = "rightContainer">
                            <p class = "white-box-heading">Account holder name</p>
                            <div class = "white-box">
                                <p class = "white-box-sub-heading">{{paymentDetails[0].value}}</p>
                                <v-icon @click="copyToClipboard(0)" class = "icons material-icons-round">content_copy</v-icon>
                            </div>
                        </div>
                    </div>
                    <p class = "waiting_text">It may take upto one working day to reflect in your investment account.</p>
                </div>
            </div>
            <v-snackbar v-model="isCopied" app timeout="8000">
            Copied to clipboard!

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isCopied = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        </div>
    </div>
</template>
<script>
import LenderService from '@/services/lenderService'

export default {
    name: 'BankTransfer',
    data () {
        return {
            lender: {
                name: 'Sudhanshu Sharda'
            },
            portfolio: null,
            paymentDetails: [],
            showAlternateProduct: '',
            showPaymentDialog: false,
            userBankAccount: null,
            userBankName: null,
            virtualAccountValue: 0,
            isCopied: false,
            virtualAccountDetails: []
        }
    },
    filters: {
        capitalize (value) {
            return value[0].toUpperCase() + value.slice(1)
        }
    },
    mounted () {
        this.$store.commit('isLoading')
        this.getVirtualAccountDetails()
        this.getUserData()
    },
    computed: {
        getPaymentDetails () {
            return [
                {
                    label: 'Beneficiary',
                    value: this.$store.state.userName || this.$store.state.onBoarding.Name
                },
                {
                    label: 'Bank',
                    value: 'Yes Bank'
                },
                {
                    label: 'Account Number',
                    value: this.virtualAccountDetails.virtualAccountNumber
                },
                {
                    label: 'IFSC Code',
                    value: this.virtualAccountDetails.ifsc
                },
                {
                    label: 'Account Type',
                    value: 'Current'
                }
            ]
        },
        getName () {
            return this.$store.state.userName || this.$store.state.onBoarding.Name
        }
    },
    methods: {
        goBack () {
            this.$router.push('/dashboard')
        },
        copyToClipboard (index) {
            navigator.clipboard.writeText(
                this.paymentDetails[index].value
            )
            this.isCopied = true
        },
        getUserData () {
            LenderService.getUserNomineeData().then((response) => {
                this.$store.commit('isLoading')
                if (response.status === 200) {
                    this.userBankAccount = response.data.result.kyc.bankAccount.bankAccountNumber
                    this.getBankName(response.data.result.kyc.bankAccount.ifsc)
                } else {
                    this.$store.commit('isNotLoading')
                }
            })
        },
        getBankName (ifsc) {
            LenderService.getIfscCode(ifsc).then((response) => {
                if (response.status === 200) {
                    this.userBankName = response.data.BANK
                    this.$store.commit('isNotLoading')
                } else if (response.status === 400) {
                    this.userBankName = 'XXXXXXXXXXXXX'
                    this.$store.commit('isNotLoading')
                } else {
                    this.$store.commit('isNotLoading')
                }
            })
        },
        getVirtualAccountDetails () {
            this.$store.commit('Loading')
            LenderService.getVirtualAccountInfo().then((res) => {
                if (res.status === 200) {
                    this.virtualAccountDetails = res.data
                    this.paymentDetails.push({
                        label: 'Beneficiary',
                        value: this.$store.state.userName || this.$store.state.onBoarding.Name
                    },
                    {
                        label: 'Bank',
                        value: 'Yes Bank'
                    },
                    {
                        label: 'Account Number',
                        value: this.virtualAccountDetails.virtualAccountNumber
                    },
                    {
                        label: 'IFSC Code',
                        value: this.virtualAccountDetails.ifsc
                    },
                    {
                        label: 'Account Type',
                        value: 'Current'
                    })
                }
                this.$store.commit('isNotLoading')
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../components/dashboard/dashboard.scss";

.padding_dashboard {
    padding-left: 100px;
    padding-right: 100px;
}
.icons {
    position: absolute;
    left: 90%;
    color: #D3D3D3 !important
}
.deposit_text {
    font-size: 13px;
    color: #8c8c8c;
    font-weight: 500;
    text-align: center;
    margin-bottom: 12px;
}
.accountEmpty_text {
    color: #232323;
    font-weight: 500;
    font-size:18px;
    text-align: center;
    margin-bottom: 2px;
}
.change_payment {
    margin-bottom: 26px;
    font-size: 13px;
    font-weight: 600 !important;
    text-align: center !important;
    color: #007AFF !important;
    text-decoration-line: underline !important;
    cursor: pointer !important;
}
.paymentContainer {
    padding-bottom: 10px;
    display: flow-root;
    flex-direction: row;
}
.bankType_text {
    float: left;
    font-weight: 700;
    font-size: 14px;
    color: #232323;
}
.amount_Text {
    float: right;
    font-weight: 700;
    font-size: 14px;
    color: #232323;

}
.amount {
    color: #002FA7 !important
}
.transfer_Text {
    font-weight: 700;
    font-size: 14px;
    color: #002FA7;
}
.bankBox {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    padding: 12px;
    padding-right: 100px;
    width: max-content;
    border-radius: 10px;
    background-color: #ffffff;
    border-style: solid;
    border-width: 1px;
    border-color: #E0E0E0;
}
.white-box {
    position: relative;
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    padding: 12px;
    border-radius: 10px;
    background-color: #ffffff;
    border-style: solid;
    border-width: 1px;
    border-color: #E0E0E0;
}
.bankName_text {
    margin-bottom: 2px;
    font-weight: 600;
    font-size: 16px;
    color: #232323;

}
.account_text {
    margin-bottom: 0px;
    font-weight: 400;
    font-size: 14px;
    color: #4F4F4F;
}
.accountDetailsContainer {
    padding-left: 20px;
}
.note {
    margin-bottom: 30px;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
}
.noteDescription {
    font-weight: 500;
    font-size: 14px;
    color: #8c8c8c;
}
.following_bank_account {
font-weight: 700;
font-size: 14px;
color: #002FA7;
}
.white-box-heading {
    margin-bottom: 12px;
    font-weight: 500;
    font-size: 12px;
    color: #4F4F4F;
}
.white-box-sub-heading {
    margin-bottom: 0px;
    font-weight: 600;
    font-size: 14px;
    color: #232323;
}
.contentContainer {
    display: flex;
    flex-direction: row;
}
.leftContainer {
    width: -webkit-fill-available !important;
    margin-right: 15px;
}

.rightContainer {
    width: -webkit-fill-available !important;
    margin-left: 15px;
}
.waiting_text {
    font-style: italic;
    font-weight: 400;
    font-size: 13px;
    color: #8C8C8C;
    text-align: right;
}
@media (max-width: 990px) {
    .contentContainer {
    display: flex;
    flex-direction: column !important;
}
    .rightContainer {
    width: -webkit-fill-available !important;
    margin-left: 0px !important;
}
    .leftContainer {
    width: -webkit-fill-available !important;
    margin-right: 0px !important;
}
    .padding_dashboard {
    padding-left: 15px !important;
    padding-right: 15px !important;
}
}
.lottiePlayerContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.congratulations {
    font-weight: 700;
    font-size: 21px;
    color: #000000;
}
.investmentFirst {
    text-align: center;
    font-weight: 500;
    font-size: 17px;
    color: #8C8C8C;
}
.investmentAmount {
    font-weight: 600;
    font-size: 24px;
    color: #232323;
}
.padding_rightpanel {
    padding-right: 0px !important;
}
</style>
